export const colors = {
	z0:  "hsla(0, 0%, 0%, 1)",
	z1: "hsla(0, 0%, 6%, 1)",
	z2: "rgba(34, 34, 34, 1)",
	z3: "rgba(46, 46, 46, 1)",
	z4: "rgba(58, 58, 58, 1)",
	z5: "rgba(70, 70, 70, 1)",
	z6: "rgba(80, 80, 80, 1)",

	accent:   "rgba(237, 0, 235, 1)",
	accent08: "rgba(237, 0, 235, .08)",
	accent20: "rgba(237, 0, 235, .2)",
	accent50: "rgba(237, 0, 235, .5)",
	accent75: "rgba(237, 0, 235, .75)",

	white: "rgba(255, 255, 255, 1)",
	white60: "rgba(255, 255, 255, 0.6)",
	white40: "rgba(255, 255, 255, 0.4)",
	white25: "rgba(255, 255, 255, 0.25)",
	white16: "rgba(255, 255, 255, 0.16)",
	white08: "rgba(255, 255, 255, 0.08)",
	white04: "rgba(255, 255, 255, 0.04)",
	white03: "rgba(255, 255, 255, 0.03)",
	white02: "rgba(255, 255, 255, 0.02)",

	text: "rgba(166, 166, 166, 1)",

	pageBackground: "hsla(0, 0%, 8%, 1)",
	tileBackground: "hsla(0, 0%, 8%, 1)",
	diagramBackground: "hsla(0, 0%, 10%, 1)",
	nullTileBackground: "hsla(0, 0%, 12%, 1)",
	pageThumbnailSelectedBackground: "hsla(0, 0%, 17%)",
	selectionRectBackground: "hsla(301, 100%, 46%, 0.05)",

	green: "rgba(48, 209, 88, 1)",
	addTile: "rgba(237, 0, 235, 1)",

	annotations: {
		yellow: { background: "rgba(255, 229, 0, 1)", foreground: "rgba(0, 0, 0, 0.9)" },
		cyan: { background: "rgba(117, 251, 220, 1)", foreground: "rgba(0, 0, 0, 0.9)" },
		magenta: { background: "rgba(237, 0, 235, 1)", foreground: "rgba(255, 255, 255, 0.9)" },
		white: { background: "rgba(255, 255, 255, 1)", foreground: "rgba(0, 0, 0, 0.9)" },
	},

	nullTileBackgrounds: {
		giphy: "rgba(38, 32, 47, 1)",
		figma: "rgba(29, 43, 36, 1)",
		airtable: "rgba(44, 29, 30, 1)",
		twitter: "rgba(21, 27, 31, 1)",
	}
};
